import { render, staticRenderFns } from "./TeachResourceBuild.vue?vue&type=template&id=5c1218b4&scoped=true"
import script from "./TeachResourceBuild.vue?vue&type=script&lang=js"
export * from "./TeachResourceBuild.vue?vue&type=script&lang=js"
import style0 from "./TeachResourceBuild.vue?vue&type=style&index=0&id=5c1218b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1218b4",
  null
  
)

export default component.exports